import { FileDownload } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
// eslint-disable-next-line no-restricted-imports -- pre-existing direct DataGridPro use; migrate to ServerDataGrid when touched
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import DataGridToolbar from '@sophocles/data-grids/components/toolbar';

function AnsiDoubleConsumptionTable({ list }) {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'moment',
        headerName: t('general.date'),
        width: 180,
        valueFormatter: value => (value ? format(value, 'P') : '—'),
      },
      {
        field: 'consumed',
        headerName: t('powerData.meter1Kwh'),
        flex: 1,
        minWidth: 120,
        type: 'number',
      },
      {
        field: 'generated',
        headerName: t('powerData.meter2Kwh'),
        flex: 1,
        minWidth: 120,
        type: 'number',
      },
    ],
    [t],
  );

  const rows = useMemo(
    () =>
      list.toJS().map((row, i) => ({
        id: i,
        ...row,
      })),
    [list],
  );

  const handleExport = useCallback(() => {
    apiRef.current.exportDataAsCsv({
      fileName: 'consumption',
      delimiter: ',',
      utf8WithBom: true,
      escapeFormulas: false,
    });
  }, [apiRef]);

  const exportButton = useMemo(
    () => (
      <Tooltip title={t('general.export', { defaultValue: 'Export' })}>
        <span>
          <IconButton size="small" onClick={handleExport}>
            <FileDownload fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    ),
    [handleExport, t],
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <DataGridToolbar apiRef={apiRef} showQuickFilter={false} toolbarActions={exportButton} />
      <DataGridPro
        apiRef={apiRef}
        rows={rows}
        columns={columns}
        initialState={{
          sorting: { sortModel: [{ field: 'moment', sort: 'desc' }] },
        }}
        density="compact"
        disableRowSelectionOnClick
        hideFooter
        autoHeight
      />
    </Box>
  );
}

export default AnsiDoubleConsumptionTable;
